<template>
  <section class="colors">
    <p class="skin-title">{{ $t('colors') }}</p>

    <div class="colors__wrapper">
      <template
          v-for="(color, index) in colors"
      >
        <nuxt-link
            v-if="index > 0 ? colors[index - 1].title !== color.title : true"
            :aria-label="color.title"
            :to="localePath(`/colors/${getModifiedString(color.title)}`)"
            class="colors__item"
        >
          <span :style="{borderColor: color.hex}" class="item-circle"></span>
          <p class="item-title">
            {{
              $t('see_color_items', {
                count: countItems?.find((item) => item.title === color.title)?.count || 0,
                color: $t('color_translates.' + getModifiedString(color.title).replace('-', '_')).toLowerCase()
                    .replace(/(ой|ый)$/i, 'ых')
              })
            }}
          </p>
          <svg height="16" width="16">
            <use xlink:href="/icons/sprite.svg#i-arrow-right-top"></use>
          </svg>
        </nuxt-link>
      </template>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type {Color, ColorItemCount} from "~/graphql/generated/schema-types";

const props = defineProps<{
  colors: Color[],
  countItems: ColorItemCount[]
}>()
const localePath = useLocalePath()
</script>

<style lang="scss" scoped>


.colors {
  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    border-radius: 8px;
    border: 1px solid var(--surfaces-high-container);
    transition: transform 0.3s;
    color: var(--surfaces-on-surface-variable);

    &:hover {
      transform: scale(1.05);
    }

    svg {
      flex-shrink: 0;
    }

    .item-circle {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 8px solid transparent;
      flex-shrink: 0;
    }

    .item-title {
      font-size: 14px;
      font-weight: 600;
      margin-right: auto;
    }
  }
}
</style>
